import Select from "react-select";
import type { Props as SelectProps } from "react-select";
import { cn } from "@/lib/utils";

type CustomSelectProps<Option, IsMulti extends boolean = false> = SelectProps<
  Option,
  IsMulti
> & {
  className?: string;
};

const selectStyles = {
  container: (base: any) => ({
    ...base,
    width: "100%",
  }),

  control: (base: any, state: any) => ({
    ...base,
    minHeight: "44px",
    height: "44px",
    backgroundColor: "var(--select-bg)",
    borderColor: state.isFocused
      ? "var(--select-border-focus)"
      : "var(--select-border)",
    boxShadow: "none",
    color: "var(--select-text)",
    borderRadius: "8px",
    "&:hover": {
      borderColor: "var(--select-border-focus)",
    },
  }),

  valueContainer: (base: any) => ({
    ...base,
    height: "44px",
    padding: "0 12px",
  }),

  input: (base: any) => ({
    ...base,
    color: "var(--select-text)",
  }),

  singleValue: (base: any) => ({
    ...base,
    color: "var(--select-text)",
  }),

  placeholder: (base: any) => ({
    ...base,
    color: "var(--select-placeholder)",
  }),

  menu: (base: any) => ({
    ...base,
    backgroundColor: "var(--select-bg)",
    border: "1px solid var(--select-border)",
    zIndex: 50,
    borderRadius: "8px",
    overflow: "hidden",
  }),

  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isFocused
      ? "var(--select-option-hover)"
      : "var(--select-bg)",
    color: "var(--select-text)",
    cursor: "pointer",
  }),

  dropdownIndicator: (base: any) => ({
    ...base,
    color: "var(--select-icon)",
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),
};

export function CustomSelect<Option, IsMulti extends boolean = false>({
  className,
  ...props
}: CustomSelectProps<Option, IsMulti>) {
  return (
    <div className={cn("w-full ", className)}>
      <Select<Option, IsMulti>
        {...props}
        styles={selectStyles}
        classNamePrefix="themed-select"
        isSearchable
      />
    </div>
  );
}
